import React, { useContext, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import UserIcon from '@mui/icons-material/Person';
import BarChartIcon from '@mui/icons-material/BarChart';
import BookIcon from '@mui/icons-material/Book';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import {Link} from 'react-router-dom'
import PaidIcon from '@mui/icons-material/Paid';
import { TOKEN_KEY } from '../../constants';
import { appContext } from '../../Context/appProvider';
import { Terms } from '../BecomeSeller';

const sidebarItems = [
    // {
    //     name: 'Analytics',
    //     Icon: BarChartIcon,
    //     path: '/analystics'
    // },
    {
        name: 'My Courses',
        Icon: BookIcon,
        path: '/my-courses'
    },
    {
        name: 'Earnings',
        Icon: AccountBalanceIcon,
        path: '/earnings'
    },
    {
        name: 'Account',
        Icon: UserIcon,
        path: '/my-account'
    }
]

export default function Sidebar() {
    const {setToken, showSidebar, setShowSidebar, setShowTerms} = useContext(appContext)
    const [show, setShow] = useState(false)

    const signout = () => {
        setToken(null)
        localStorage.removeItem(TOKEN_KEY)
    }

    return (
        <div className={'z-[99999] w-[300px] max-md:top-[70px] max-md:absolute top-0 shadow-sm bg-white h-full gap-6 flex flex-col pt-4 pb-6 overflow-auto transition-all duration-500 ease-in-out p-5 ' + (showSidebar ? 'max-md:translate-x-[0]' : 'max-md:translate-x-[-100%]')}>
            {sidebarItems.map(item => (
                <Link to={item.path} onClick={e => setShowSidebar(false)} className='flex items-center justify-between'>
                    <div className='flex items-center gap-2'>
                        {<item.Icon style={{color: '#000000b5', fontSize: 20}}>Filled</item.Icon>}
                        <p className='text-[15px] text-[#000000b5]' href='/'>{item.name}</p>
                    </div>
                    <ArrowForwardIosIcon style={{color: '#000000b5', fontSize: 16}}>Filled</ArrowForwardIosIcon>
                </Link>
            ))}
            <button onClick={signout} className='flex gap-2 items-center text-sm mt-auto self-center'>
                <LogoutIcon style={{color: '#000000b5', fontSize: 20}}>Filled</LogoutIcon>
                Sign Out
            </button>
            <button className='text-sm text-main underline' onClick={() => setShowTerms(true)}>Terms and Coditions</button>
        </div>
    )
}
